import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import FileUpload from "@/components/churchbuilder/FileUpload";
import { inp, lbl } from "./ListingForm";

const FIELDS = [
  ["eyebrow", "Eyebrow"], ["title", "Headline *"], ["highlight", "Gold highlight words"],
  ["primary_label", "Primary button label"], ["primary_url", "Primary button link"],
  ["secondary_label", "Secondary button label"], ["secondary_url", "Secondary button link"],
];

export default function HeroEditor() {
  const [h, setH] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let live = true;
    api.get("/admin/marketplace/hero").then((r) => live && setH((prev) => prev || r.data)).catch(() => toast.error("Could not load hero"));
    return () => { live = false; };
  }, []);

  const save = async () => {
    setSaving(true);
    try { const { updated_at, ...body } = h; const r = await api.put("/admin/marketplace/hero", body); setH(r.data); toast.success("Hero saved"); }
    catch { toast.error("Save failed — headline is required"); }
    finally { setSaving(false); }
  };

  if (!h) return <Loader2 className="animate-spin text-[#D4AF37]" />;
  return (
    <div data-testid="mkt-hero-editor" className="grid md:grid-cols-2 gap-4 max-w-4xl">
      {FIELDS.map(([k, l]) => (
        <div key={k} className={k === "title" ? "md:col-span-2" : ""}>
          <label className={lbl}>{l}</label>
          <input data-testid={`mkt-hero-${k}`} className={inp} value={h[k] || ""} onChange={(e) => setH({ ...h, [k]: e.target.value })} />
        </div>
      ))}
      <div className="md:col-span-2">
        <label className={lbl}>Subtitle</label>
        <textarea rows={3} data-testid="mkt-hero-subtitle" className={inp} value={h.subtitle || ""} onChange={(e) => setH({ ...h, subtitle: e.target.value })} />
      </div>
      <div className="md:col-span-2">
        <FileUpload value={h.image_url} onChange={(url) => setH({ ...h, image_url: url })} label="Hero image (16:9, 1920×1080 recommended)" testid="mkt-hero-image" />
      </div>
      <div className="md:col-span-2">
        <button onClick={save} disabled={saving} data-testid="mkt-hero-save" className="btn-gold px-6 py-2.5 rounded text-xs tracking-widest uppercase inline-flex items-center gap-2">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save hero
        </button>
      </div>
    </div>
  );
}
